<template>
  <div class="absolute inset-0 overflow-hidden pointer-events-none deco-bg">
    <div class="absolute -top-20 -right-8 w-56 h-[380px] rotate-[20deg] rounded-[36px] deco-top"></div>
    <div class="absolute -bottom-16 -left-12 w-72 h-72 rounded-full deco-bottom"></div>
  </div>
</template>

<style scoped>
.deco-top {
  background: linear-gradient(180deg, rgba(6, 200, 255, 0.09) 0%, transparent 55%);
}
.deco-bottom {
  background: radial-gradient(circle, rgba(6, 200, 255, 0.06) 0%, transparent 60%);
}

:is(.dark *).deco-top {
  background: linear-gradient(180deg, rgba(6, 200, 255, 0.15) 0%, transparent 55%);
}

/* On desktop, push deco below the header chrome so it doesn't
   bleed through the frosted-glass topbar / subnav */
@media (min-width: 1280px) {
  .deco-top {
    top: calc(var(--topbar-height, 55px) + 50px);
  }
}
:is(.dark *).deco-bottom {
  background: radial-gradient(circle, rgba(6, 200, 255, 0.04) 0%, transparent 50%);
}
</style>
